import React, {useEffect} from 'react';
import {changeBottomNavigation, changeTitle, setStateGoBackUrl, showMenuNavBar} from "../../actions";
import {connect} from "react-redux";
import {withTranslation} from 'react-i18next';
import {compose} from 'redux';
import ErrorRequestHandler from "../../components/ErrorRequestHandler";
import PresentationComponent from "../../components/Route/PresentationComponent";
import {useMatomo} from "@datapunt/matomo-tracker-react";
import usePresentation from "../../hooks/usePresentation";
import {useParams} from "react-router-dom";

const PresentationScreen = ({t, i18n, onTitleChange, onBottomNavigationChange, onShowMenuNavBar, routePresentation, setGoBackUrl}) => {
    const {slugpresentation} = useParams();

    const { status, data: presentation, error } = usePresentation(i18n.language, slugpresentation);
    const { trackPageView } = useMatomo();

    if (routePresentation) {
        setGoBackUrl(routePresentation);
    }

    useEffect(() => {
        const title = (presentation?.label) ? presentation.label : "";
        onTitleChange(title);
        onShowMenuNavBar(false);

        if (title !== "") {
            trackPageView({
                documentTitle: title, // optional
                href: window.location.pathname,
            });
        }

    }, [t, onTitleChange, onBottomNavigationChange, onShowMenuNavBar]);

    if (presentation?.label || status === "success") {
        const title = (presentation?.label) ? presentation.label : "";
        onTitleChange(title);

        if (title !== "") {
            trackPageView({
                documentTitle: title, // optional
                href: window.location.pathname,
            });
        }
    }

    return (<>
        {status  === 'pending' && <div className={"loadingWrapper"}>
            <div id="loading"/>
        </div>}

        {status === 'error' && error && <ErrorRequestHandler error={error} />}

        {status === "success" && presentation?.id && <PresentationComponent
            presentation={presentation}
        />}
    </>);
}

const mapStateToProps = (state) => {
    return {
        routePresentation: state.navbar.routePresentation,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onTitleChange: (title) => {
            dispatch(changeTitle(title))
        },
        onBottomNavigationChange: (icons) => {
            dispatch(changeBottomNavigation(icons))
        },
        onShowMenuNavBar: (showMenuNavBarBool) => {
            dispatch(showMenuNavBar(showMenuNavBarBool))
        },
        setGoBackUrl: (url, params) => {
            dispatch(setStateGoBackUrl(url, params))
        },
    }
}

export default
    compose(
        withTranslation(),
        connect(
            mapStateToProps,
            mapDispatchToProps
        ))(PresentationScreen);